import React, { useMemo, useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Form, Formik } from "formik";
import editIcon from "../../Images/edit.svg";
import deleteIcon from "../../Images/Delete.svg";
import { Language } from "../../utilities/constants";
import { read } from "../../DataApi/read";
import { write } from "../../DataApi/write";
import { useSession } from "../../authentications/SessionContext";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import LoaderWrapper from "../Loader/LoaderWrapper";
import FormikInput from "../Formik/FormikInput";
import FormikSelect from "../Formik/FormikSelect";
import cameraIcon from "../../Images/camera.svg";
import { newUserFormValidationSchema } from "../../utilities/Validation Schema/NewUserFormValidationSchema";
import ErrorFocus from "../Formik/ErrorFocus";
import { USER_DETAIL_KEYS } from "../../utilities/constants";
import { onChangeUser } from "../../DataApi/users/onChangeUser";
import { create } from "../../DataApi/create";
import SVGButton from "../Buttons/SVGButton";
import { nameSearchCRM } from "../../DataApi/crm/nameSearchCRM";
import UploadedImage from "../UploadedImagedComponent/UploadedImage";
import { fileToBase64 } from "../../utilities/fileToBase64";
import { useSnackbar } from "notistack";
import { FormContainer } from "../StyledComponents/FormConatiner/FormContainerStyle";
import { Button } from "../../Components/StyledComponents/Buttons/ButtonStyle";
import useConfirmationModal from "../ConfirmationModal/useConfirmationModal";
import { handleResponse } from "../../utilities/handleResponse";
import useFormikSubmitButton from "../../CustomHooks/useFormikSubmitButton";
import { primaryColor } from "../../utilities/colors";

const StyledLabel = styled.label`
  color: #535559;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
`;

// const Button = styled.button`
//   background-color: #cbcbcb;
//   color: #535559;
//   width: 280px;
//   min-width: 160px;
//   border: none;
//   border-radius: 15px;
//   padding: 10px 20px;
//   font-family: "Inter";
//   font-size: 18px;
//   font-weight: 600;
//   cursor: pointer;
//   transition: background-color 0.3s, color 0.3s;

//   &:hover,
//   &:focus,
//   &:active {
//     background-color: #ff5837;
//     color: #fff;
//   }
// `;
const ImageContainer = styled.div`
  border-radius: 10px;
  background-color: #f5f5f5;
  border: 1px solid #cbcbcb;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 190px;
  min-width: 103px;
  height: 165px;
`;

const NewUserForm = ({ handleCloseModal, selectedUser }) => {
  const { sessionInfo } = useSession();
  const { company_id, context, user_id, isVTEX } = sessionInfo;

  const { language, translations } = useLanguage();
  const t = translations[language];
  const { ConfirmationModal, toggleModal, setMetaData, setTitle } =
    useConfirmationModal();
  const { setIsSubmitting, FormikSubmitButtons } = useFormikSubmitButton();
  const { enqueueSnackbar } = useSnackbar();

  const [previousInputs, setPreviousInputs] = useState({});

  const [view, setView] = useState("add");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const image1920Ref = useRef();
  const [showPassword, setShowPassword] = useState(false);
  const [groupsID, setGroupsID] = useState([]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    login: "",
    image_1920: "",
    default_code: "",
    password: "",
    new_password: "",
    designation: "",
    phone: "",
  });
  const fetchUserDetail = async () => {
    setIsLoading(true);
    let response = await read({
      id: selectedUser,
      context,
      company_id,
      change: USER_DETAIL_KEYS,
      model: "res.users",
    });
    response = JSON.parse(response)?.result?.[0];
    // console.log("response", response);
    let inputList = {
      ...response,
      name: response?.name,
      login: response?.login,
      image_1920: response?.image_1920,
      designation: response?.designation,
      phone: response?.phone,
    };
    setFormData({ ...inputList });
    setPreviousInputs({ ...inputList });
    inputList = {};
    setIsLoading(false);
  };

  const getPayload = (payload) => ({
    name: payload?.name || "",
    login: payload?.login || "",
    // email: payload?.login || "",
    // image_1920: payload?.image_1920 || false,
    created_by_merchant: true,
    password: payload?.password || false,
    new_password: payload?.new_password || false,
    // designation: payload?.designation || false,
    phone: payload?.phone || false,
    sel_groups_1_9_10: payload?.sel_groups_1_9_10 || 1,
  });

  const handleAddUser = async (values) => {
    const payload = { ...getPayload(values), groups_id: [6, false, groupsID] };
    let response = await create({
      payload,
      context,
      company_id,
      model: "res.users",
    });
    response = JSON.parse(response);
    if (response.result) {
      handleCloseModal();
    }
    return response;
  };

  const handleEditUserForm = async (values) => {
    const newChanges = {};
    const oldPayload = getPayload(previousInputs);
    const newPayload = getPayload(values);

    Object.keys(newPayload).forEach((key) => {
      if (JSON.stringify(newPayload[key]) != JSON.stringify(oldPayload[key])) {
        newChanges[key] = newPayload[key];
      }
    });

    if (Object.keys(newChanges).length === 0) {
      handleCloseModal();
      return;
    }
    let response = await write({
      id: formData.id,
      change: { ...newChanges },
      company_id,
      context,
      model: "res.users",
    });
    response = JSON.parse(response);
    if (response.result) {
      handleCloseModal();
    }
    return response;
  };
  const handleSubmitForm = async (...args) => {
    setIsSubmitting(true);
    let response = {};
    let successMessage = "User Created Successfully";
    if (view === "edit") {
      successMessage = "User Edited Successfully";
      response = await handleEditUserForm(...args);
    } else if (view === "add") {
      response = await handleAddUser(...args);
    }
    setIsSubmitting(false);
    toggleModal();
    handleResponse({
      response,
      setMetaData,
      setTitle,
      successMessage,
    });
    setIsLoadingSubmit(false);
  };

  const handleChangeimage1920 = (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      fileToBase64(file, (_, base64) => setFieldValue("image_1920", base64));
    }
  };

  useEffect(() => {
    if (selectedUser) {
      setView("view");
      fetchUserDetail();
    } else {
      setView("add");
      onChangeUser({ context, company_id })
        .then((userOnChangeResp) => {
          userOnChangeResp = JSON.parse(userOnChangeResp);
          let userGroupsId = userOnChangeResp?.result?.value?.groups_id;
          userGroupsId = userGroupsId.flat();
          // console.log("on change response", userOnChangeResp, userGroupsId);

          setGroupsID(userGroupsId);
        })
        .catch((error) => {
          console.error("Error fetching user change response:", error);
        });
    }
  }, [selectedUser]);

  const disableInputs = useMemo(() => view === "view", [view]);
  return (
    <LoaderWrapper isLoading={isLoading} height="50vh" width="800px">
      <ConfirmationModal />
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={newUserFormValidationSchema(view === "add")}
        onSubmit={handleSubmitForm}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <div
              className="container"
              style={{ maxWidth: "900px", padding: "10px" }}
            >
              <FormContainer className="row g-3">
                <div className="row p-0 justify-content-between align-items-center">
                  <div className="col">
                    <h3
                      className="me-2 mb-2 "
                      style={{
                        fontFamily: "Inter",
                        color: "#323B4B",
                        fontWeight: 600,
                      }}
                    >
                      {!selectedUser && t["Create New User"]}
                      {selectedUser && view === "edit" && t["Edit User"]}
                      {selectedUser && view === "view" && t["User"]}
                    </h3>
                  </div>
                  {view === "view" && (
                    <div className="col d-flex justify-content-end p-0">
                      <SVGButton
                        hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
                        icon={editIcon}
                        onClick={() => {
                          setView("edit");
                        }}
                        className="me-2"
                      />
                    </div>
                  )}

                  <div className="d-flex flex-column flex-md-row justify-content-between">
                    <div className="d-flex flex-column mb-3 col-12- col-md-8">
                      <div className=" col-12  ">
                        <FormikInput
                          disabled={disableInputs}
                          type="text"
                          name="name"
                          label={t["Name"]}
                        />
                      </div>

                      <div>
                        <div className=" d-none mt-4 mb-2">
                          <div>
                            <input
                              type="checkbox"
                              id="option4"
                              value="option4"
                              name="in_group_60"
                              className=" ms-2 radio_input"
                            />
                            <StyledLabel className="ms-2">
                              Created by merchant
                            </StyledLabel>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="product_image_container mb-2"
                      onClick={() => {
                        if (!disableInputs) image1920Ref.current.click();
                      }}
                    >
                      <UploadedImage src={values.image_1920 || cameraIcon} />
                      <input
                        ref={image1920Ref}
                        type="file"
                        name="image_1920"
                        hidden
                        onChange={(e) =>
                          handleChangeimage1920(e, setFieldValue)
                        }
                      />
                    </div>
                  </div>
                  <hr />
                </div>

                <div className="col-md-6">
                  <FormikInput
                    name="login"
                    type="text"
                    placeholder="Email"
                    label={t["Email"]}
                    disabled={disableInputs}
                  />
                </div>

                {/* {view === "edit" && ( */}
                <div className="col-md-6">
                  <div className="position-relative">
                    <button
                      type="button"
                      className="btn position-absolute"
                      style={{
                        top: "42px",
                        right: "10px",
                        color: "#4E5D78",
                      }}
                      onClick={togglePasswordVisibility}
                    >
                      <i
                        className={`fa ${
                          showPassword ? "fa-eye-slash" : "fa-eye"
                        }`}
                      ></i>
                    </button>
                    <FormikInput
                      name="password"
                      type={showPassword ? "text" : "password"}
                      placeholder={t["New Password"]}
                      className="form-control"
                      label={t["New Password"]}
                      disabled={disableInputs}
                      style={{ paddingRight: "2.5rem" }}
                    />
                  </div>
                </div>
                {/* )} */}
                {isVTEX && (
                  <>
                    <div className="col-md-6">
                      <FormikInput
                        name="phone"
                        magic={true}
                        type="text"
                        placeholder="Phone"
                        label={t["Phone"]}
                        disabled={disableInputs}
                        style={{
                          borderBottomLeftRadius: "13px !important",
                          borderTopLeftRadius: "13px !important",
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <FormikInput
                        name="designation"
                        type="text"
                        placeholder="Designation"
                        label={t["Designation"]}
                        disabled={disableInputs}
                      />
                    </div>
                  </>
                )}
                {/* <div className="col-md-6">
                  <FormikSelect
                    name="lang"
                    label={t["Language"]}
                    options={Language}
                    disabled={disableInputs}
                  />
                </div> */}
                {/* <div className=" mt-4 mb-2">
                  <div>
                    <input
                      type="checkbox"
                      id="option1"
                      value="option1"
                      className=" ms-2 radio_input d-none "
                    />
                    <StyledLabel className="ms-2 d-none">
                      Two factor authentication
                    </StyledLabel>
                  </div>
                </div> */}
                {!disableInputs && (
                  <FormikSubmitButtons handleCloseModal={handleCloseModal} />
                )}
              </FormContainer>
            </div>
            {/* <ErrorFocus /> */}
          </Form>
        )}
      </Formik>
    </LoaderWrapper>
  );
};

export default NewUserForm;
